import { lighten } from "@mui/system";

const styles = (theme) => ({
  title: { fontWeight: "bold", fontSize: "20px" },
  paperContainer: {
    p: 1,
    borderRadius: "16px",
    display: "flex",
    flexDirection: "column",
    gap: 1,
  },
  boxContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: 2,
  },
  boxEdit: {
    p: 2,
    display: "flex",
    flexDirection: "column",
    gap: 1,
  },
  BoxInfo: {
    display: "flex",
    gap: 2,
    flexDirection: { xs: "column", md: "row" },
    alignItems: { xs: "stretch", md: "flex-start" },
  },
  textField: {
    flex: { xs: "1 1 auto", md: "0 0 400px" }, // No desktop fica fixo em 400px, no mobile cresce
    width: "100%",
  },
  paperInfo: {
    p: 1.5,
    flex: 1,
    borderRadius: "8px",
    bgcolor: "action.hover",
    display: "flex",
    alignItems: "center",
    minHeight: "48px",
    borderStyle: "dashed",
  },
  textInfo: {
    fontSize: "13px",
    color: "text.secondary",
    lineHeight: 1.4,
  },
  switch: {
    width: 42,
    height: 26,
    padding: 0,
    "& .MuiSwitch-switchBase": {
      padding: 0,
      margin: 0.2,
      transitionDuration: "300ms",
      "&.Mui-checked": {
        transform: "translateX(16px)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          backgroundColor: theme.palette.primary.main,
          opacity: 1,
          border: 0,
        },
        "&.Mui-disabled + .MuiSwitch-track": {
          opacity: 0.5,
        },
      },
      "&.Mui-focusVisible .MuiSwitch-thumb": {
        color: theme.palette.primary.main,
        border: "6px solid #fff",
      },
      "&.Mui-disabled .MuiSwitch-thumb": {
        color:
          theme.palette.mode === "dark"
            ? theme.palette.grey[600]
            : theme.palette.grey[100],
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: theme.palette.mode === "dark" ? 0.3 : 0.7,
      },
    },
    "& .MuiSwitch-thumb": {
      boxSizing: "border-box",
      width: 22,
      height: 22,
    },
    "& .MuiSwitch-track": {
      borderRadius: 26 / 2,
      backgroundColor:
        theme.palette.mode === "dark"
          ? lighten(theme.palette.colors.black.dark, 0.07)
          : theme.palette.colors.gray.medium,
      opacity: 1,
      transition: theme.transitions.create(["background-color"], {
        duration: 500,
      }),
    },
  },
  icon: {
    fontSize: 22,
    color: theme.palette.white.main,
  },
  titleSwitch: {
    fontWeight: 600,
    ml: 1,
    fontSize: "0.85rem",
    userSelect: "none",
  },
  paperDatagrid: {
    width: "100%",
    overflowX: "auto",
    backgroundColor: theme.palette.background.paper,
    borderRadius: "16px",
    height: "100%",
    maxHeight: "400px",
  },
  paperBody: {
    p: 2,
    borderRadius: "16px",
    display: "flex",
    flexDirection: "column",
    gap: 2,
    backgroundColor: theme.palette.background.wallpaper,
  },
  subtitle: {
    fontWeight: "bold",
    fontSize: "10px",
    color: theme.palette.text.secondary,
    ml: 1,
  },
  containerHeader: {
    p: 1,
  },
  containerActions: {
    p: "10px 15px",
    width: "100%",
    justifyContent: "flex-end",
    display: "flex",
    borderTop: `1px solid ${theme.palette.divider}`,
  },
});
export default styles;
